import * as React from "react";
import { TanStackTable } from "../../../../components/Table/Table";
import { RowInfo } from "../../../../components/Table/Migration/LegacyTypes";
import * as _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { EditActions, editActions } from "../../../../actions/editActions";
import classNames from "classnames";
import styles from "./DataSections.module.scss";
import trash from "../../../../images/trash.svg";

export type StateProps = {
  editedEnumeration: Api.IoBasicDataType;
  columns: State.ColumnMap;
};

export type TableProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rows: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isRowSelected: (row: any) => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleRowSelection: (row: any) => void;
  columnType?: string;
};

type DispatchProps = {
  editActions: typeof editActions;
};

export type Props = StateProps & TableProps & DispatchProps;

class DataSections extends React.Component<Props> {
  render() {
    const { rows, columns, columnType, editedEnumeration } = this.props;
    const selectedColumns: State.Column[] = columns[columnType as keyof State.ColumnMap];
    return (
      <div className={styles.container}>
        <TanStackTable
          rows={rows}
          pageSize={rows.length as any}
          disablePagination={true}
          isHidingTextActive={false}
          handleRowSelection={this.props.handleRowSelection}
          isRowSelected={this.props.isRowSelected}
          columns={
            (columnType === "IO Data Sections" || columnType === "IO Data Sections Select"
              ? selectedColumns
              : [
                  ...selectedColumns,
                  {
                    Header: "",
                    id: "removeIcon",
                    accessor: "showRemove",
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Cell: (props: any) => (
                      <span className={styles.remove}>
                        <img
                          className={styles.removeIcon}
                          src={trash}
                          alt="Remove"
                          onClick={() =>
                            this.props.editActions.setEdited({
                              ...editedEnumeration,
                              iodataSections: _.filter(
                                editedEnumeration.iodataSections,
                                item => item.id !== props.original.id
                              )
                            })
                          }
                        />
                      </span>
                    ),
                    width: 48,
                    minWidth: 30,
                    filterable: false
                  }
                ]) as any
          }
          style={{ display: "flex", flex: 1, overflow: "auto" }}
          className="-striped -highlight data-sections"
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          getTdProps={(e: any, rowInfo?: RowInfo) => {
            if (rowInfo !== undefined) {
              return {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onClick: (event: any) => {
                  event.stopPropagation();
                  this.props.handleRowSelection(rowInfo.row._original);
                },
                className: styles.selectableRow
              };
            } else {
              return {};
            }
          }}
          getTrProps={(e: Event, rowInfo?: RowInfo) => {
            if (rowInfo !== undefined) {
              return {
                className: classNames({
                  [styles.selectedRow]: this.props.isRowSelected(rowInfo.original)
                })
              };
            } else {
              return {};
            }
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: State.Root) => ({
  columns: state.columns,
  editedEnumeration: state.editView.editedObject
});
const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DataSections);
